import { useDiaryContext } from "../../../../context/DiaryContext";
import { HeaderContainer } from "../../../Layout/HeaderContainer/HeaderContainer";
import { AccessHeaderLogo } from "../../../Shared/Buttons/AccessHeaderLogo";
import { MenuButton } from "../../../Shared/Buttons/MenuButton";
import { ToggleView } from "../SubHeader/SubHeader";
import { DateSelector } from "./DateSelector/DateSelector";
import { VenueSelectorEDS } from "./VenueSelector/VenueSelectorEDS";

export const DiaryHeader = () => {
  const { selectedView } = useDiaryContext();
  return (
    <HeaderContainer
      featureSentimentName={getFeatureName(selectedView)}
      start={
        <>
          <MenuButton />
          <AccessHeaderLogo />
        </>
      }
      middle={<DateSelector />}
      end={<VenueSelectorEDS dir={"rtl"} />}
    />
  );
};

const getFeatureName = (view: ToggleView): string => {
  switch (view) {
    case "DiaryTab":
      return "Diary View";
    case "FloorplanTab":
      return "Floorplan View";
    case "RunsheetTab":
      return "Runsheet View";
    default:
      return "Diary View";
  }
};
